import { render, staticRenderFns } from "./CartPreview.vue?vue&type=template&id=a1062bd4&scoped=true"
import script from "./CartPreview.vue?vue&type=script&lang=ts"
export * from "./CartPreview.vue?vue&type=script&lang=ts"
import style0 from "./CartPreview.vue?vue&type=style&index=0&id=a1062bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1062bd4",
  null
  
)

export default component.exports